/** @jsxImportSource @emotion/react */
import React from 'react'
import { ListItemsForm, ListItemsPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/ListItemsContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, listItemsManagement } = breadcrumbItems

const ListItemsCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <ListItemsForm />
        </div>
        <div css={styles.right}>
          <ListItemsPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ListItemsCreate;
